/**
 * SharePoint server-relative folder paths for funding PDFs (Rodwell House).
 * Used by getPdfDownloadUrl() and must stay in sync with server PDF_ALLOWED_PATHS.
 */
export const RODWELL_WEBLINKS = '/sites/WebDocuments/Shared Documents/General/Rodwell/Weblinks';

export const RODWELL_ARCHIVE_WEBLINKS =
  '/sites/WebDocuments/Shared Documents/General/Rodwell/Archive/Weblinks';
